import { api } from '../baseApi';
import { arrayParamsSerializer } from '../helpers';
import { makeRequest } from '../makeRequest';
import type { GetClusterKeysRequest, GetClusterKeysResponse } from './dto';
import { ClusterAPIRoutes } from './route';

export function fetchClusterKeys(params: GetClusterKeysRequest): Promise<GetClusterKeysResponse> {
  return makeRequest(
    api.get(ClusterAPIRoutes.identifyCluster(), {
      params,
      paramsSerializer: arrayParamsSerializer,
    }),
  );
}
